import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
@Component({
  selector: 'app-cargoes-transfer',
  templateUrl: './transfer.component.html',
})
export class TransferComponent {
  @Input() customStyle: string;
  @Input() dataSource: any;
  @Input() disabled: boolean;
  @Input() titles: string[] = ['', ''];
  @Input() operations: string[] = ['', ''];
  @Input() listStyle: any;
  @Input() itemUnit: string;
  @Input() itemsUnit: string;
  @Input() renderList: TemplateRef<void>[] | null;
  @Input() footer: TemplateRef<void> | null;
  @Input() showSearch: boolean;
  @Input() filterOption: (inputValue: string, item: any) => boolean;
  @Input() searchPlaceholder: string;
  @Input() notFoundContent: string;
  @Input() selectedKeys: string[];
  @Input() targetKeys: string[];

  @Output() selectEvent = new EventEmitter();
  @Output() changeEvent = new EventEmitter();
  @Output() searchEvent = new EventEmitter();

  selectOrigin(e: any) {
    this.selectEvent.emit(e);
  }

  changeOrigin(e: any) {
    this.changeEvent.emit(e);
  }

  searchChange(e: any) {
    this.searchEvent.emit(e);
  }
}
